<div class="d-flex navigation-header">
    <h1 (click)="goBack()" id="panel">{{"admin.title" | translate }}</h1>
    <h1>&nbsp; > {{"admin.accounts.title" | translate}}</h1>
    <mat-form-field color="standart" [ngClass]="(isEnglish()) ? 'search-input-en' : 'search-input-de'">
        <mat-label>{{"admin.accounts.customerNumber" | translate }}</mat-label>
        <input matInput [(ngModel)]="customerNumberSearch" (keydown.enter)="search()"
                        (ngModelChange)="customerNumberSearch.length == 0 && search()">
    </mat-form-field>
    <app-search-button (click)="search()" style="margin-right: 20px;"></app-search-button>
    <button mat-flat-button color="primary" (click)="openNewAccountDialog()" class="action-button">{{'admin.accounts.addNew' | translate}}</button>
</div>
<div class="order-table">
    <table mat-table [dataSource]="items" matSort (matSortChange)="sortData($event)" class="mat-elevation-z8">

        <ng-container matColumnDef="customerName">
            <th mat-header-cell *matHeaderCellDef [width]="400" mat-sort-header="customerName">{{"admin.accounts.customerName" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.customerName}}</td>
        </ng-container>

        <ng-container matColumnDef="customerNumber">
            <th mat-header-cell *matHeaderCellDef [width]="400" mat-sort-header="customerNumber">{{"admin.accounts.customerNumber" | translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.customerNumber}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.accounts.status.title" | translate}}</th>
            <td mat-cell *matCellDef="let row">
                <img *ngIf="row.active" src="assets/img/icons/activated.svg" [matTooltip]="'admin.accounts.status.active' | translate" matTooltipPosition="above"/>
                <img *ngIf="!row.active" src="assets/img/icons/deactivated.svg" [matTooltip]="'admin.accounts.status.notActive' | translate" matTooltipPosition="above"/>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-header">{{"admin.accounts.actions" | translate}}</th>
            <td mat-cell *matCellDef="let row" class="actions">
                <div class="d-flex">
                    <img src="assets/img/icons/edit.svg" [matTooltip]="'home.orders.tooltips.edit' | translate" matTooltipPosition="above" (click)="openEditAccountDialog(row)">
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 7, 10]" showFirstLastButtons color="standart" #userPaginator="matPaginator"></mat-paginator>
</div>
